import { render, staticRenderFns } from "./special.vue?vue&type=template&id=78b2fad6&scoped=true&"
import script from "./special.vue?vue&type=script&lang=ts&"
export * from "./special.vue?vue&type=script&lang=ts&"
import style0 from "./special.vue?vue&type=style&index=0&id=78b2fad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b2fad6",
  null
  
)

export default component.exports